import type { ChoiceResult } from '@core-api/presentation/types/response';

export const getIdentitiesWithNameFallback = (
  identities: ChoiceResult[] | null,
) => {
  if (!identities) {
    return null;
  }
  return identities.map((identity) => ({
    choiceId: identity.legacyChoiceId,
    participants:
      getParticipantsWithNameFallback(identity.participantIdentities) ?? [],
  }));
};

export const getParticipantsWithNameFallback = (
  participants: ChoiceResult['participantIdentities'] | undefined,
) => {
  if (!participants) {
    return null;
  }
  return participants.map((participant) => ({
    ...participant,
    displayName: participant.displayName || 'unknown',
  }));
};
